module.exports = __webpack_public_path__ + "img/ak1.843a777f.webp";